import React from 'react'
import { useTranslation } from 'react-i18next'
import PlaceholderPage from '../PlaceholderPage'

function PrivacyPolicyPage() {
  const { t } = useTranslation()
  return <PlaceholderPage title={t('privacy_policy') || 'Privacy policy'} />
}

export default PrivacyPolicyPage
